import React, { Component } from 'react';

import {
    Container,
    Loading,
    Select,
    MultiSelect,
    Form,
    TextInput,
} from 'library';
import { UserValidator, ajax_wrapper, get_global_state } from 'functions';
import { DropboxExplorer } from 'components';

export default class CreateSync extends Component {
    constructor(props) {
        super(props);

        let checker = new UserValidator();

        let params = get_global_state()['params'];
        let project_id = params['id'] ? params['id'] : this.props.project_id;

        this.state = {
            loaded: false,
            data: {},
            ml_selectors: [],
            project_id: project_id,

            is_staff: checker.is_staff(),

            selected_files: [],
            selected_folder: [],
            features: ['bpm', 'key', 'ml_analyze'],
        };
    }

    componentDidMount() {
        ajax_wrapper(
            'GET',
            `/api/get_ml_options/${this.state.project_id}/`,
            {},
            (value) => {
                this.load_ml_options(value);
            },
        );

        if (this.state.project_id) {
            this.refresh_project();
        } else {
            this.setState({ loaded: true });
        }

        if (this.state.dropbox_creds) {
            this.search();
        }
    }

    load_ml_options = (value) => {
        let ml_models = value['ml_models'];
        let tag_types = value['tag_types'];

        let ml_selectors = [];

        for (let tagtype_id of Object.keys(tag_types)) {
            let ml_options = [];
            for (let model of ml_models) {
                if (model.model_type === tagtype_id) {
                    ml_options.push({ text: model.name, value: model.id });
                }
            }

            if (ml_options.length !== 0) {
                ml_selectors.push(
                    <Select
                        name={tagtype_id}
                        label={tag_types[tagtype_id].name}
                        options={ml_options}
                    />,
                );
            }
        }

        this.setState({
            ml_selectors: ml_selectors,
            tag_types: tag_types,
        });
    };

    refresh_project = () => {
        ajax_wrapper(
            'GET',
            `/api/home/project/${this.state.project_id}/`,
            {},
            (value) => this.setState({ loaded: true, data: value }),
        );
    };

    submit = (state) => {
        let ml_selections = [];
        for (let type of Object.keys(this.state.tag_types)) {
            if (Object.keys(state).includes(type)) {
                ml_selections.push(state[type]);
            }
        }

        let project_id = this.state.data.id;
        var folder_name = state.selected_folder.join('/');

        let url = `/api/create_dropbox_sync/${project_id}/`;
        let data = {
            folder_name: folder_name,
            files: state.selected_files,
            bpm: true,
            key: true,
            ml_selections: ml_selections,
        };

        ajax_wrapper(
            'POST',
            url,
            data,
            function (value) {
                if ('error' in value) {
                    this.setState({ error: value['error'] });
                } else {
                    let split_num = value['split_redirect'];
                    window.location.href = `/project/${project_id}/${split_num}/`;
                }
            }.bind(this),
        );
    };

    submit_track = (state) => {
        let project_id = this.state.data.id;
        let url = `/api/create_track/${project_id}/`;
        let data = { track_title: state.track_title };
        ajax_wrapper(
            'POST',
            url,
            data,
            function (value) {
                if ('error' in value) {
                    console.log('error');
                    this.setState({ error: value['error'] });
                } else {
                    let split_num = value['split_redirect'];
                    window.location.href = `/project/${project_id}/${split_num}/`;
                }
            }.bind(this),
        );
    };

    render() {
        let display_ml = this.state.is_staff;

        let select_options = [
            { text: 'BPM Analyzer', value: 'bpm' },
            { text: 'Key Finder', value: 'key' },
        ];

        if (display_ml) {
            select_options.push({
                text: 'Machine Learning',
                value: 'ml_analyze',
            });
        }

        return (
            <Container>
                <Loading loaded={this.state.loaded}>
                    <div
                        className="simple-card-container"
                        style={{ marginBottom: '80px' }}
                    >
                        <div className="simple-card">
                            <div class="page-header">
                                <h1>{`Add New Songs To Project: ${this.state.data.name}`}</h1>
                            </div>
                        </div>

                        <div className="simple-card">
                            <h4>Add Single Track (no Audio):</h4>
                            <Form
                                submit={this.submit_track}
                                submit_text="Add track"
                                submit_button_type="success"
                            >
                                <TextInput
                                    placeholder="Track Title..."
                                    name="track_title"
                                    style={{
                                        width: '60%',
                                        marginBottom: '10px',
                                        color: 'black',
                                    }}
                                />
                            </Form>
                        </div>
                        <Form
                            defaults={{
                                features: this.state.features,
                                selected_files: this.state.selected_files,
                                selected_folder: this.state.selected_folder,
                            }}
                            submit={this.submit}
                            submit_text="Import Selected Files"
                            submit_button_type="success"
                            buttons_className="simple-card fixed-floating-card-bottom"
                        >
                            {/*                            <MultiSelect
                                className="simple-card"
                                checkbox
                                name="features"
                                label="Features"
                                options={select_options}
                            />*/}

                            <div
                                className="simple-card"
                                style={{
                                    display: display_ml ? 'block' : 'none',
                                }}
                            >
                                <h5>ML Models</h5>
                                {this.state.ml_selectors}
                            </div>

                            <DropboxExplorer
                                files_name="selected_files"
                                folder_name="selected_folder"
                                redirect_url={`project/${this.state.data.id}/add_songs`}
                            />
                        </Form>
                    </div>
                </Loading>
            </Container>
        );
    }
}
